import React, { useContext } from "react";
import ShowSubContext from "../ShowSubContext";

export const useShowSub = () => {
    const context = useContext(ShowSubContext);
    if (context === undefined) {
        throw new Error('useShowSub must be used within a ShowSubProvider');
    }
    return context;
};

